import {
  isUserFetching,
  shouldShowTeacherPortal
} from "../../../../redux/bridge/selectors";
import { connect } from "react-redux";
import React from "react";
import TeacherView from "./teacher-view";
import DefaultView from "./default-view";
import {
  getSubscriptionFromRoute,
  isNative
} from "../../../../redux/router/selectors";

function ExplorerTab({
  shouldShowTeacherLink,
  bridgeUserFetching,
  native,
  subscriptionVbid
}) {
  if (bridgeUserFetching) {
    // Candy stripe rendering handled outside this component
    return <div />;
  } else if (shouldShowTeacherLink && !native) {
    return <TeacherView />;
  }

  return <DefaultView native={native} subscriptionVbid={subscriptionVbid} />;
}

const mapStateToProps = state => {
  return {
    shouldShowTeacherLink: shouldShowTeacherPortal(state),
    bridgeUserFetching: isUserFetching(state),
    native: isNative(state),
    subscriptionVbid: getSubscriptionFromRoute(state)
  };
};

export default connect(mapStateToProps, null)(ExplorerTab);
